import React from "react";
import { Box, Grid } from "@mui/material";

const Possibility = ({ img, title, exp }) => {
	return (
		<Grid
			item
			md={3}
			sm={12}
			sx={{
				mx: 1,
				border: "1px solid #bdbdbd",
				backgroundColor: "white",
				mb: 5,
				pb: 2,
				borderRadius: "20px",
				position: "relative",
				minHeight: "350px",
				maxWidth: "40px",
			}}
		>
			<Box
				sx={{
					position: "absolute",
					left: 0,
					top: 0,
					width: "100%",
					height: "250px",
					borderRadius: "20px",
					backgroundSize: "cover",
					backgroundPosition: "bottom 250px left 0px",
					backgroundRepeat: "none",
					backgroundImage: `url(${img})`,
				}}
			></Box>
			<Box
				sx={{
					backgroundColor: "white",
					position: "absolute",
					left: 0,
					bottom: 20,
					width: "100%",
					height: "42%",
					borderTop: "1px solid #bdbdbd",
				}}
			>
				<Box sx={{ px: 3, pt: 3, fontSize: "21px", fontWeight: 500 }}>
					{title}
				</Box>
				<Box sx={{ px: 3, pt: 2, fontSize: "14px", lineHeight: "1.9em" }}>
					{exp}
				</Box>
			</Box>
		</Grid>
	);
};

export default Possibility;
